import {
  Grid,
  Typography,
  TableRow,
  TableBody,
  TableHead,
  Divider,
  Table,
  TableContainer,
  Paper,
  Switch,
  Box,
  useTheme,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, useContext } from "react";
import { centsToLocalString, getCurrencyUnit } from "../shared/money";
import { AppContext } from "../contextProviders/AppContext";

import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Cancel, Clear, Euro } from "@mui/icons-material";
import { ThemeContext } from "@emotion/react";

/* const useStyles = makeStyles((theme) => {
  return {
    groupHeader: {
      height: "50px",
      color: "#052659",
    },
    groupContainer: {
      paddingTop: "5px",
      flexDirection: "column",
    },
    groupField: {
      height: "50px",
      backgroundColor: "#efefef",
    },
    groupHighlight: {
      backgroundColor: "#e9f8e2",
      borderRadius: 4,
      borderStyle: "solid",
      borderColor: "#528d36",
      borderWidth: 1,
    },
  };
});
 */
function GroupFieldContent({ field, service }) {
  if (field?.type === "money") {
    return (
      <Typography variant="h5" component="div" style={{ margin: 0 }}>
        {`${centsToLocalString(service.deductibleValue, true)}`}
      </Typography>
    );
  }
  if (field?.type === "boolean") {
    if (field.value) {
      return <CheckIcon color="primary" />;
    } else {
      return <ClearIcon color="error" />;
    }
  }
  return "";
}

export default function GroupedService({ parent, services, mobileViewPort }) {
  const [enabledService, setEnabledService] = useState(null);

  const { setSelectedAdditionalServices } = useContext(AppContext);

  // Only keep one service from the group chosen at time.
  const handleChange = (service) => {
    const newService = { ...service, quantity: 1 };
    if (enabledService) {
      if (enabledService?.id === service.id) {
        // Chosen service is being removed
        setEnabledService(null);
        setSelectedAdditionalServices((services) =>
          services.filter((s) => s.id !== service.id)
        );
      } else {
        // Chosen service is being changed
        setSelectedAdditionalServices((services) =>
          services.map((s) => (s.id === enabledService.id ? newService : s))
        );
        setEnabledService(service);
      }
    } else {
      // New chosen service is added
      setEnabledService(service);
      setSelectedAdditionalServices((services) => [...services, newService]);
    }
  };

  if (mobileViewPort) {
    return (
      <Grid item xs={12} style={{ marginTop: 25 }}>
        <Typography variant="h5">{parent.description}</Typography>
        <Typography variant="body1">{parent.description2}</Typography>
        <Paper style={{ marginTop: 25 }}>
          <Grid container direction="row" justifyContent="space-between">
            {services.map((c, idx) => {
              return (
                <Grid
                  item
                  xs={5}
                  style={{
                    ...(idx === services.length - 1
                      ? {
                          backgroundColor: "#e9f8e2",
                          borderRadius: 4,
                          borderStyle: "solid",
                          borderColor: "#528d36",
                          borderWidth: 1,
                        }
                      : {}),
                  }}
                >
                  <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    style={{ marginTop: 10, marginBottom: 10 }}
                  >
                    <Typography variant="h5">{c.description}</Typography>
                    <Typography variant="body2" align="center">
                      {c.offerPrice
                        ? `${centsToLocalString(c.offerPrice, true)}`
                        : "Ilmainen"}
                    </Typography>
                    <Switch
                      size="medium"
                      checked={c.id === enabledService?.id}
                      onChange={() => handleChange(c)}
                    />
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
          <Divider />
          <Grid item xs={12}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <TableContainer>
                <Table>
                  <TableBody>
                    {services.map((c, idx) => {
                      if (enabledService && enabledService.id === c.id)
                        return (
                          <>
                            {c.groupFields.map((field, fieldIdx) => {
                              return (
                                <TableRow>
                                  <TableCell>{field.description}</TableCell>
                                  <TableCell align="center">
                                    <GroupFieldContent
                                      field={field}
                                      service={c}
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </>
                        );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  }

  return (
    <Box container id="parent" style={{ marginTop: "30px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "30px",
          maxWidth: "70%",
        }}
      >
        <Typography variant="h5">{parent.description}</Typography>
        <Typography variant="body1">{parent.description2}</Typography>
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <TableContainer sx={{ maxWidth: "70%" }}>
          <Table
            sx={{
              [`& .${tableCellClasses.root}`]: {
                borderBottom: "none",
                borderCollapse: undefined,
              },
            }}
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ padding: 0 }} />

                {services.map((item, index) => {
                  return (
                    <TableCell
                      key={item.id}
                      sx={{
                        padding: 0,

                        width: "100px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          paddingBottom: "20px",
                          paddingTop: 0,
                          bgcolor: index === 1 ? "#e8f8e1" : undefined,
                          borderStyle: index === 1 ? "solid" : undefined,
                          borderTopWidth: 1,
                          borderLeftWidth: 1,
                          borderRightWidth: 1,
                          borderBottomWidth: 0,
                          borderColor: "darkgreen",
                          alignItems: "flex-start",
                          paddingTop: "30px",
                          paddingLeft: "15px",
                          paddingRight: "15px",
                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            justifyContent: "center",
                          }}
                        >
                          {item.description}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "15px",
                          }}
                        >
                          hinta tähän
                        </Box>
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {parent.groupFields.map((row, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={{
                      bgcolor: "#f8f8f8",
                    }}
                  >
                    <TableCell
                      sx={{
                        padding: 0,
                        paddingLeft: "25px",
                        width: "200px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          minHeight: "100%",
                        }}
                      >
                        {row.description}
                      </Box>
                    </TableCell>
                    <PrintValues
                      target={row.description}
                      indexValue={index}
                      services={services}
                      parent={parent}
                    />
                  </TableRow>
                );
              })}
              <TableRow>
                <TableCell sx={{ padding: 0 }} />

                {services.map((item, index) => {
                  return (
                    <TableCell
                      key={item.id}
                      sx={{
                        padding: 0,
                        maxWidth: "50px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "20px",
                          paddingTop: 0,
                          bgcolor: index === 1 ? "#e8f8e1" : undefined,
                          borderStyle: index === 1 ? "solid" : undefined,
                          borderTopWidth: 0,
                          borderLeftWidth: 1,
                          borderRightWidth: 1,
                          borderBottomWidth: 1,
                          borderColor: "darkgreen",
                          paddingTop: "30px",
                          paddingLeft: "15px",
                          paddingRight: "15px",
                          borderBottomLeftRadius: "10px",
                          borderBottomRightRadius: "10px",
                        }}
                      >
                        <Switch
                          size="medium"
                          checked={item.id === enabledService?.id}
                          onChange={() => handleChange(item)}
                        />
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

const PrintValues = ({ target, indexValue, services, parent }) => {
  const theme = useTheme();
  return (
    <>
      {services.map((service, serviceIndex) => {
        return service.groupFields.map((f) => {
          if (f.description === target) {
            return (
              <TableCell
                key={`${indexValue}+${f.description}`}
                sx={{ padding: 0 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    bgcolor: serviceIndex === 1 ? "#e8f8e1" : undefined,
                    borderStyle: serviceIndex === 1 ? "solid" : undefined,
                    borderTopWidth: 0,
                    borderLeftWidth: 1,
                    borderRightWidth: 1,
                    borderBottomWidth: 0,
                    borderColor: "darkgreen",
                    flexDirection: "column",
                    alignItems: "center",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {f.type === "money" && (
                      <Typography sx={{ fontSize: "16px" }}>
                        {centsToLocalString(f.value)}{" "}
                        <span style={{ fontWeight: 550 }}>
                          {getCurrencyUnit()}
                        </span>
                      </Typography>
                    )}
                    {f.type === "boolean" && f.value === true && (
                      <CheckIcon sx={{ color: theme.palette.success.main }} />
                    )}
                    {f.type === "boolean" && f.value === false && (
                      <Clear sx={{ color: theme.palette.error.main }} />
                    )}
                  </Box>
                </Box>
              </TableCell>
            );
          }
        });
      })}
    </>
  );
};
